import React from "react";
import Text from "../../../../../../library/text";
import "./style.scss";

const Index = () => {
  return (
    <div className="single-no-company-notes-container text-center">
      <h1 className="no-notes-icon">
        <i className="far fa-sticky-note"></i>
      </h1>
      <Text maxWidth={315} align="center">
        Du har ingen notater på denne bedriften enda. Du kan legge til et nytt
        notat nedenfor.
      </Text>
    </div>
  );
};

export default Index;
